import { useTranslation } from "react-i18next";
import { Link, Typography } from "@mui/material";

import { useConfigParameters } from "hooks/configParametersHooks";
import { useMeasureTemplateUrl } from "hooks/uploadHooks";

import { ErrorFormat } from "utils/ErrorUtils";
import { MeasureImpact } from "types/types";

import { UploadDropZone } from "components/upload/UploadDropZone";

interface Props {
  selectedMeasure: MeasureImpact;
  fileUploadErrors: ErrorFormat[];
  setAcceptedFiles: (files: File[]) => void;
  setFileUploadErrors: (errors: ErrorFormat[]) => void;
  geometryType: string;
}

export function UploadMeasure(props: Props) {
  const {
    geometryType,
    fileUploadErrors,
    setAcceptedFiles,
    setFileUploadErrors,
    selectedMeasure,
  } = props;
  const { t } = useTranslation();
  const { data: config } = useConfigParameters();
  const { data: measureTemplateUrl } = useMeasureTemplateUrl(
    selectedMeasure.measure?.key || ""
  );
  return (
    <>
      <Typography>{t("label.uploadZipWithShapefile")}</Typography>
      <ul>
        <li> {t("label.shapefileUploadCondition1")}</li>
        <li>
          {t("label.shapefileUploadCondition2", {
            geometryType:
              geometryType === "POINT"
                ? t("label.points")
                : t("label.polygons"),
          })}
        </li>
        <li>
          {t("label.shapefileUploadCondition3", {
            geometryType:
              geometryType === "POINT"
                ? t("label.points")
                : t("label.polygons"),
          })}
        </li>
        <li>
          {t("label.shapefileUploadCondition4", {
            geometryType:
              geometryType === "POINT"
                ? t("label.polygons")
                : t("label.points"),
          })}
        </li>
        <li>{t("label.shapefileUploadCondition5")}</li>
        <li>{t("label.shapefileUploadCondition6")}</li>
        <li>
          {t("label.shapefileUploadCondition7", {
            geometryType:
              geometryType === "POINT"
                ? t("label.points")
                : t("label.polygons"),
          })}
        </li>
      </ul>

      <UploadDropZone
        setAcceptedFiles={setAcceptedFiles}
        maxUploadSizeMB={config?.maxUploadSizeMB || 0}
        errors={fileUploadErrors}
        resetErrors={() => setFileUploadErrors([])}
      />
      <Link mt={2} href={measureTemplateUrl} download>
        {t("label.downloadExampleFile")}: {selectedMeasure?.measure.name}
      </Link>
    </>
  );
}
